import { useMemo } from "react";
import { LoanApplicationCaseStatus, LoanApplicationStatus } from "./api/types";
import { LoanApplication } from "../contexts";

/**
 * Dashboard should show payments only when loan is active,
 * and it is not Invoice Discounting
 * */
export const useLoanApplicationPaymentsEnabled = (
  loan: LoanApplication | undefined
) => {
  return useMemo(() => {
    return (
      loan &&
      (loan?.status === LoanApplicationStatus.ACTIVE ||
        loan?.status === LoanApplicationStatus.PARTIALLY_DISBURSED ||
        loan.caseStatus === LoanApplicationCaseStatus.ACTIVE)
    );
  }, [loan]);
};
